let lastAuthEventAt = 0;

export function markAuthEvent(): void {
  lastAuthEventAt = Date.now();
}

export function msSinceLastAuthEvent(): number {
  return lastAuthEventAt === 0 ? Number.POSITIVE_INFINITY : Date.now() - lastAuthEventAt;
}

export function waitForAuthSettle(minMs = 300): Promise<void> {
  const delta = msSinceLastAuthEvent();
  if (delta >= minMs) {
    if (import.meta.env.DEV) {
       
      console.log('[AUTH EVT] waitForAuthSettle immediate', { delta, minMs, waitMs: 0 });
    }
    return Promise.resolve();
  }
  if (import.meta.env.DEV) {
     
    console.log('[AUTH EVT] waitForAuthSettle', { delta, minMs, waitMs: minMs - delta });
  }
  return new Promise((resolve) => setTimeout(resolve, minMs - delta));
}
